// extracted by mini-css-extract-plugin
module.exports = {"section":"styles-module--section--3BmyJ","holder":"styles-module--holder--1zRLq","card":"styles-module--card--2SAXJ"};